import { createAsyncThunk } from '@reduxjs/toolkit';
//import httpService from '@/rtk-apis/axios-config/http-service';
import { GET_USERLIST } from '@custom/constant';
import { _auditUrls } from '@custom/Utils/constants/apiUrls';
//import { CANDIDATE_LIST } from '@/rtk-apis/end-points';

const auditList = createAsyncThunk('patientList', async (obj:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_auditUrls.list}`
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(obj)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default auditList;
